export default __webpack_public_path__ + "static/media/Payroll-2.a66065ac.png";